import utils from 'components/utilsComponent';
import metrikaCollector, {collectYandexReachGoal} from 'components/metrika';
import ModalRecallCreate from './modal-recall-create';
import Select from 'components/select';
import {isMobile, formData} from 'methods/utils';
import {ajaxGetData} from 'methods/ajaxData';

new Select(document.querySelector('.Recall-filter .Select[data-name="year"]'));
new Select(document.querySelector('.Recall-filter .Select[data-name="city"]'));
new Select(document.querySelector('.Recall-filter .Select[data-name="sort"]'));

const modalRecallCreate = new ModalRecallCreate();
const $modalAddRecall = document.querySelector('.js-modalAddRecall');
$modalAddRecall.addEventListener('click', () => {
    modalRecallCreate.open();

    // клик по кнопке "написать отзыв"
    if (typeof yaCounter46243086 !== "undefined") {
        yaCounter46243086.reachGoal('owner_review');
        collectYandexReachGoal(metrikaCollector, 'owner_review');
    }
});

/**
 * Подгрузка списка отзывов
 */
document.addEventListener('click', e => {
    if (!e.target.matches('.js-more-recalls')) {
        return;
    }

    const $button = e.target.closest('.js-more-recalls');
    if ($button.classList.contains('is-loading')) {
        return false;
    }
    $button.classList.add('is-loading');

    const $buttonWrapper = $button.closest('.js-more-recalls-wrapper');
    const $recallsBlock  = document.querySelector('.js-recallsBlock');
    const $recallsList   = document.querySelector('.js-recallsList');
    const url            = $button.dataset.href;
    let page             = $button.dataset.page;

    fetch(url, {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData({
            'page': page,
        }),
    })
    .then(response => response.json())
    .then(r => {
        if (r.status != 'ok') {
            throw r;
        }

        return r;
    })
    .then(r => {
        // удаляем последнюю кнопку
        $buttonWrapper.parentElement.removeChild($buttonWrapper);

        // добавляем контент
        $recallsBlock.dataset.page = r.data.page;
        $recallsList.insertAdjacentHTML('beforeend', r.data.recalls_list);

    })
    .catch(r => {
        //
    })
    .finally(() => {
        $button.classList.remove('is-loading');
    });
});

/**
 * Обработка фильтров: "Город объекта", "Год написания отзыва" + сортировка
 */
document.addEventListener('change', e => {
    if (!e.target.matches('input[name="city"]') && !e.target.matches('input[name="year"]') && !e.target.matches('input[name="sort"]')) {
        return;
    }
    const $recallsList = document.querySelector('.js-recallsList');
    const url          = '/about/ajax_recalls/';
    let year           = document.querySelector('.Select[data-name="year"] input').value
    let city           = document.querySelector('.Select[data-name="city"] input').value
    let sort           = document.querySelector('.Select[data-name="sort"] input').value
    fetch(url, {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData({
            'year': year,
            'city': city,
            'sort': sort,
        }),
    })
        .then(response => response.json())
        .then(r => {
            console.log(r)
            if (r.status != 'ok') {
                throw r;
            }

            return r;
        })
        .then(r => {
            // удаляем предыдущие отзывы
            $recallsList.innerHTML = '';

            // добавляем контент
            $recallsList.insertAdjacentHTML('beforeend', r.data.recalls_list);

        })
        .catch(r => {
            //
        })
        .finally(() => {
            //
        });

});
